<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="installation">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="JODA icon"
                    class="img-raised rounded-circle img-fluid"
                  />
                </div>
                <div class="name">
                  <h3 class="title">Installation</h3>
                  <h6>安裝 JODA</h6>
                  <p class="description text-center">
                    請選擇您使用的行動平台
                  </p>
                  <!-- <md-button
                    href="javascript:void(0)"
                    class="md-just-icon md-simple md-dribbble"
                    ><i class="fab fa-dribbble"></i
                  ></md-button>
                  <md-button
                    href="javascript:void(0)"
                    class="md-just-icon md-simple md-twitter"
                    ><i class="fab fa-twitter"></i
                  ></md-button>
                  <md-button
                    href="javascript:void(0)"
                    class="md-just-icon md-simple md-pinterest"
                    ><i class="fab fa-pinterest"></i
                  ></md-button> -->

                  <!-- <div id="images">
                    <div class="md-layout">
                      <div
                        class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
                        :class="{ 'text-center': responsive }"
                      >
                        <h4>Android</h4>
                        <img
                          :src="img_android_qrcode"
                          alt="JODA Google Play Page"
                          class="img-raised rounded"
                          :class="{ 'responsive-image': responsive }"
                        />
                      </div>
                      <div
                        class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
                        :class="{ 'text-center': responsive }"
                      >
                        <h4>iOS</h4>
                        <img
                          :src="img_ios_qrcode"
                          alt="Raised Image"
                          class="img-raised rounded"
                          :class="{ 'responsive-image': responsive }"
                        />
                      </div>
                    </div>
                  </div> -->

                  <!-- <div class="md-layout">
                    
                    <div
                      class="md-layout-item md-size-20 md-xsmall-size-100"
                      :class="{ 'text-center': responsive }"
                    >
                      <h4>Android</h4>
                      <img
                        :src="img_android_qrcode"
                        alt="JODA Google Play Page"
                        class="img-raised rounded"
                        :class="{ 'responsive-image': responsive }"
                      />
                    </div>
                    <div
                      class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto"
                      :class="{ 'text-center': responsive }"
                    >
                      <h4>iOS</h4>
                      <img
                        :src="img_ios_qrcode"
                        alt="JODA iOS App Store Page"
                        class="img-raised rounded"
                        :class="{ 'responsive-image': responsive }"
                      />
                    </div>
                  </div> -->

                </div>
              </div>
              
            </div>
          </div>

          <div class="text-center margin_bottom_80">
            <div class="md-layout">
              <div
                class="md-layout-item md-size-20 md-xsmall-size-100 mx-auto"
                :class="{ 'text-center': responsive }"
              >
                <h3>Android</h3>
                <p>手機掃碼安裝</p>
                <img
                  :src="img_android_qrcode"
                  alt="JODA Google Play Page"
                  class="img-raised rounded"
                  :class="{ 'responsive-image': responsive }"
                />
                <div>
                  <md-button class="md-primary md-round margin_top_20"
                  @click="goGooglePlay()">Android 點擊安裝</md-button>
                </div>
              </div>
              <div
                class="md-layout-item md-size-20 md-xsmall-size-100 mx-auto"
                :class="{ 'text-center': responsive }"
              >
                <h3>iOS</h3>
                <p>手機掃碼安裝</p>
                <img
                  :src="img_ios_qrcode"
                  alt="Raised Image"
                  class="img-raised rounded"
                  :class="{ 'responsive-image': responsive }"
                />
                <div>
                  <md-button class="md-primary md-round margin_top_20"
                  @click="goAppStore()">iOS 點擊安裝</md-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    

  </div>
</template>

<script>
export default {
  bodyClass: "installation-page",
  data() {
    return {
      responsive: false
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/skate.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/app_icon.png")
    },
    img_android_qrcode: {
      type: String,
      default: require("@/assets/img/joda_android.png")
    },
    img_ios_qrcode: {
      type: String,
      default: require("@/assets/img/joda_ios.png")
    }
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    goAppStore() {
      window.location.href = "https://itunes.apple.com/tw/app/joda/id1461836831"
    },
    goGooglePlay() {
      window.location.href = "http://play.google.com/store/apps/details?id=today.sofasogood.android.badminton"
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.margin_top_20 {
  margin-top: 20px;
}

.margin_bottom_80 {
  margin-bottom: 80px;
}

</style>
